const Loader = () => (
  <div className="loader-w">
    <div className="loader-center">
      <ul>
        {Array(25)
          .fill(0)
          .map((_, i) => (
            <li key={i} />
          ))}
      </ul>
    </div>
  </div>
);

export default Loader;
